import React, {useContext, useRef} from 'react'
import { makeStyles, withStyles} from 'external/material'
import Popper from '@mui/material/Popper'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'

import {TeacherContext} from 'teacher/context'

import CreateExamn from './create-examn'
import CartQuestion from './cart-question'

const useStyles = makeStyles(cartPopperStyles)
const useToolTipStyles = makeStyles(tooltipStyles)

export default function CartPopper(props) {

  const context = useContext(TeacherContext)
  const classes = useStyles()
  const tooltipClasses = useToolTipStyles()

  const {quizQuestionBankCart: cart, translate, quizQuestionBankCartEl, updateState} = context

  const open = Boolean(quizQuestionBankCartEl)

  const handleTooltipClose = () => updateState({quizQuestionBankCartEl: {$set: null}})

  return (
    <Tooltip
      classes={tooltipClasses}
      title={
        <Box className={classes.paper}>
          <Box className={classes.header}>
            {translate('selected-questions')}
          </Box>
          <Box className={classes.questions}>
            {cart.map((question, index) => (<CartQuestion key={index} {...{index, ...question}} />))}
          </Box>
          <Box className={classes.create}>
            <CreateExamn />
          </Box>
        </Box>
      }
      onClose={handleTooltipClose}
      open={open}
      arrow
      interactive
      disableHoverListener
      disableFocusListener
      disableTouchListener
    >
      {props.children}
    </Tooltip>
  )
}

function tooltipStyles (theme) {
  return {
    popperInteractive: {
      display: 'flex',
      maxHeight: '80%',
    },
    tooltip: {
      fontSize: '11pt',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      border: 'solid 1px rgb(99 96 96 / 90%)',
      padding: 0,
      maxWidth: 400,
      minWidth: 300,
      '& > div': {
        border: 0
      },
      '& .header': {
        padding: 5,
        display: 'flex',
        justifyContent: 'flex-end'
      },
      '& .close': {
        color: 'rgb(99 96 96 / 90%)',
        cursor: 'pointer'
      }
    },
  }
}


function cartPopperStyles(theme) {
  return  {
    paper: {
      display: 'flex',
      overflowY: 'hidden',
      flexDirection: 'column',
      maxWidth: 600,
      minWidth: 400,
      minHeight: 300,
      maxHeight: 450,
      background: '#fff',
      border: 'solid 1px #bfcdd8',
      borderRadius: 5,
      marginTop: 5
    },
    header: {
      padding: '12px 8px',
      color: '#71768c',
      borderBottom: 'solid 1px #bfcdd8'
    },
    questions: {
      padding: '9px',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowY: 'auto'
    },
    create: {
      display: 'flex',
      padding: 8,
      borderTop: 'solid 1px #bfcdd8',
    }
  }
}
